import React, { forwardRef, useCallback, useEffect, useImperativeHandle, useRef, useState } from 'react'
import PropTypes from 'prop-types'
import noop from 'lodash/noop'
import { makeStyles } from '@material-ui/core'
import clsx from 'clsx'
import Icon from '../../atoms/Icon'

const useStyles = makeStyles((theme) => ({
  sydInput: {
    height: '100%',
    minWidth: '30rem',
    width: '100%',
    border: `1px solid ${theme.palette.gray.dark}`,
    borderRadius: '4px',
    padding: '0 1rem 0 .7rem',
    backgroundColor: theme.palette.white,
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    transition: 'outline 200ms ease-in-out',
    outline: '1px solid transparent',
    '&:focus-within': {
      outline: `1px solid ${theme.palette.primary.main}`
    },
    '& > input': {
      lineHeight: '2rem',
      backgroundColor: 'transparent',
      fontFamily: theme.typography.fontFamily,
      width: '100%',
      border: 'none',
      fontSize: '1rem',
      borderTopRightRadius: '1.5rem',
      borderBottomRightRadius: '1.5rem',
      '&:focus': {
        outline: 'none'
      },
      '&:-webkit-input-placeholder': {
        opacity: '0.2',
        fontWeight: 'bold'
      }
    },
    '& .__icon': {
      marginRight: '5px'
    }
  }
}))

const SydInput = forwardRef(function SydInput ({
  className,
  onChange = noop,
  placeholder,
  iconName,
  defaultValue
}, ref) {
  const classes = useStyles()
  const [value, setValue] = useState(defaultValue)
  useImperativeHandle(ref, () => ({
    clear: () => setValue(defaultValue),
    value
  }), [value, defaultValue])

  const handleChange = useCallback((e) => {
    setValue && setValue(e.target.value)
  }, [setValue])

  useEffect(() => {
    onChange?.(value)
  }, [value, onChange])

  const inputRef = useRef(null)

  return (
    <div className={clsx(classes.sydInput, className)}>
      {iconName ? (
        <Icon additionalClasses='__icon' name={iconName} customSize='1.5rem' />
      ) : null}
      <input
        ref={inputRef}
        value={value}
        onChange={handleChange}
        placeholder={placeholder}
      />
    </div>
  )
})

SydInput.propTypes = {
  className: PropTypes.string,
  onChange: PropTypes.func,
  placeholder: PropTypes.string,
  iconName: PropTypes.string,
  defaultValue: PropTypes.string
}

SydInput.defaultProps = {
  defaultValue: ''
}

export default SydInput
